import { NOTIFICATIONS } from '_constants';

export const notifications = (state = {}, action) => {
  const newState = { ...state };
  switch (action.type) {
    case NOTIFICATIONS.GET_NOTIFICATIONS:
      newState.notifications = action.value;
      break;
    case NOTIFICATIONS.GET_NOTIFICATIONS_COUNT:
      newState.notificationsCount = action.value;
      break;
    default:
      break;
  }
  return newState;
};
